module.exports = __webpack_public_path__ + "img/t-8.157df9d5.jpg";